import { TranslatedCopy } from "utilities/interfaces/culture-resources";
import { Map } from "utilities/types/map";

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

enum ReportType {
    InstructorLedTrainingEvent = 1,
    Organization = 2,
    OnlineLearningTraining = 3,
}

const ReportTypeDisplayNames: Map<ReportType, TranslatedCopy> = {
    [ReportType.InstructorLedTrainingEvent]: "instructorLedTrainingEvent",
    [ReportType.Organization]: "organization",
    [ReportType.OnlineLearningTraining]: "onlineLearningTraining",
};

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { ReportType, ReportTypeDisplayNames };

// #endregion Exports
